var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFilterConversation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1084 5.75L9.00007 12.3333M8.50007 5.75H19.5001C20.4167 5.75 21.1667 6.5 21.1667 7.41667V9.25C21.1667 9.91667 20.7501 10.75 20.3334 11.1667L16.7501 14.3333C16.2501 14.75 15.9167 15.5833 15.9167 16.25V19.8333C15.9167 20.3333 15.5834 21 15.1667 21.25L14.0001 22C12.9167 22.6667 11.4167 21.9167 11.4167 20.5833V16.1667C11.4167 15.5833 11.0834 14.8333 10.7501 14.4167L7.5834 11.0833C7.16674 10.6667 6.8334 9.91667 6.8334 9.41667V7.5C6.8334 6.5 7.5834 5.75 8.50007 5.75Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFilterConversation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-filter-conversation.628ecb37f853809be6e583e9834d50fa.svg";